var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css, styled } from 'styled-components';
import { getCssVariableValue, pxToRem } from "../../utils";
export var StyledTooltipArrow = styled.span.withConfig({
  displayName: "styled__StyledTooltipArrow",
  componentId: "1_5_0__sc-xdo6q4-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    &,\n    &::before {\n      height: ", ";\n      position: absolute;\n      width: ", ";\n    }\n\n    &::before {\n      background: ", ";\n      content: '';\n      transform: rotate(45deg);\n    }\n\n    [data-popper-placement='bottom'] & {\n      top: ", "rem;\n    }\n\n    [data-popper-placement='top'] & {\n      bottom: ", "rem;\n    }\n  "])), theme.vars.spacing_03, theme.vars.spacing_03, theme.vars.tooltip_overlay_color_background, parseFloat(getCssVariableValue(theme.vars.spacing_03) || '0') * -0.5, parseFloat(getCssVariableValue(theme.vars.spacing_03) || '0') * -0.5);
});
var StyledTooltipChildrenContainerCss = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  max-height: 15rem;\n  overflow: auto;\n\n  ", "\n\n  ", "\n"])), function (_ref2) {
  var $noTitle = _ref2.$noTitle,
    theme = _ref2.theme;
  return $noTitle && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      margin-right: ", ";\n    "])), theme.vars.spacing_04);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.vars.tooltip_text_css_line_height && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      & .csl-typography {\n        line-height: ", ";\n      }\n    "])), function (_ref4) {
    var theme = _ref4.theme;
    return theme.vars.tooltip_text_css_line_height;
  });
});
export var StyledTooltipChildrenContainer = styled.span.withConfig({
  displayName: "styled__StyledTooltipChildrenContainer",
  componentId: "1_5_0__sc-xdo6q4-1"
})(["", "{", "}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.cssPrefix;
}, StyledTooltipChildrenContainerCss);
export var StyledTooltipContent = styled.span.withConfig({
  displayName: "styled__StyledTooltipContent",
  componentId: "1_5_0__sc-xdo6q4-2"
})(["", "{", "}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.cssPrefix;
}, function (_ref7) {
  var theme = _ref7.theme;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      background: ", ";\n      ", "\n      display: block;\n      font-size: ", ";\n      line-height: ", ";\n      max-width: ", "rem;\n      padding: ", ";\n    "])), theme.vars.tooltip_overlay_color_background, theme.vars.tooltip_overlay_size_border_radius !== '0rem' && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        border-radius: ", ";\n      "])), theme.vars.tooltip_overlay_size_border_radius), theme.vars.text_s2_font_size, theme.vars.text_s2_line_height, pxToRem(336), theme.vars.spacing_04);
});
export var StyledTooltipTitle = styled.span.withConfig({
  displayName: "styled__StyledTooltipTitle",
  componentId: "1_5_0__sc-xdo6q4-3"
})(["", "{display:block;margin-bottom:", ";}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.cssPrefix;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.vars.spacing_03;
});
export var StyledTooltipClose = styled.button.withConfig({
  displayName: "styled__StyledTooltipClose",
  componentId: "1_5_0__sc-xdo6q4-4"
})(["", "{", "}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.cssPrefix;
}, function (_ref11) {
  var theme = _ref11.theme;
  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      background: none;\n      border: none;\n      cursor: pointer;\n      float: right;\n      margin-left: ", ";\n      padding: 0;\n\n      &:focus {\n        box-shadow: ", ";\n        outline: ", "rem solid transparent;\n        outline-offset: ", "rem;\n      }\n    "])), theme.vars.spacing_01, theme.button_box_shadow_focus_css, pxToRem(2), pxToRem(2));
});
export var StyledTooltipMask = styled.span.withConfig({
  displayName: "styled__StyledTooltipMask",
  componentId: "1_5_0__sc-xdo6q4-5"
})(["", "{bottom:0;left:0;position:fixed;right:0;top:0;z-index:1;}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.cssPrefix;
});
var StyledTooltipCss = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref13) {
  var $closed = _ref13.$closed,
    theme = _ref13.theme;
  return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    margin: ", "rem;\n    z-index: 5;\n\n    ", "\n\n    &:focus {\n      outline: ", "rem solid transparent;\n      outline-offset: ", "rem;\n    }\n  "])), 2 * parseFloat(getCssVariableValue(theme.vars.spacing_03) || '0') * 2 * 0.5 / 2, $closed && css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      display: none;\n    "]))), pxToRem(2), pxToRem(2));
});
export default styled.span.withConfig({
  displayName: "styled",
  componentId: "1_5_0__sc-xdo6q4-6"
})(["", "{", "}"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.cssPrefix;
}, StyledTooltipCss);